/* @flow */

import { responseHasError } from '../diplomatico/reducers/helper';
import type { Action } from '../diplomatico/types';
import { enableInitializing } from 'initializable-reducer';
import mergeWithReplace from '../helpers/mergeWithReplace';

const initialState = {};

function studentIntelligenceProgress(state: Array<Object> = initialState, { type, payload }: Action) {
  switch (type) {
    case 'RESPONSE_STUDENT_INTELLIGENCE_PROGRESS':
      if (responseHasError(payload)) {
        return state;
      }

      const { student_id } = payload._meta.payload.request;

      const newProgress = {
        [student_id]: payload.body
      };

      return mergeWithReplace({}, [state, newProgress]);
    default:
      return state;
  }
}

export {
  studentIntelligenceProgress,
  initialState
};

export default enableInitializing(studentIntelligenceProgress);
